import React, { Component } from "react";
import {
  Button,
  Menu,
  Card,
  Dimmer,
  Loader,
  Breadcrumb,
} from "semantic-ui-react";
import { translate } from "react-i18next";
import { withRouter } from "react-router-dom";

import NewProfileForm from "../homepage/NewProfileForm";
import NewChapterForm from "../../components/project/NewChapterForm";
import ChapterUI from "../../components/project/ChapterUI";
import Can from "../Permission";
import { Link } from "react-router-dom";

import { escapeQuotes } from "../../store/functionUtils";
import { connect } from "react-redux";
import {
  chapterDataFetchData,
  chapterDataCreateData,
  chapterDataDeleteData,
  chapterDataUpdateData,
  chapterDataFetchDataSuccess,
  duplicateChapter,
} from "../../store/actions/ChapterFetchActions";
import {
  projectDataUpdateData,
  projectDataFetchDataSuccess,
} from "../../store/actions/ProjectFetchActions";
import { selectedProjectID } from "../../store/actions/CardUIActions";
import gql from "graphql-tag";

class Project extends Component {
  componentDidMount() {
    let currentProjectId = this.props.match.params.projectid;
    this.props.fetchChapter(null, 30, 1, currentProjectId);
    this.props.selectedProjectID(currentProjectId);
  }

  // Create a new chapter
  createNewChapter(title) {
    let currentProjectId = parseInt(this.props.match.params.projectid, 10);
    const data = {
      caa_project_id: currentProjectId,
      chapt_title: escapeQuotes(title),
      chapt_content: "",
      chapt_row: "",
      chapt_typo: "",
      chapt_user_block: 0,
      content: { data: {} },
      row: { data: {} },
      content_alt: { data: {} },
      typo: { data: {} },
    };

    let query = gql`
      mutation createChapter(
        $objects: [simcaa_t_projects_chapt_insert_input!]!
      ) {
        insert_simcaa_t_projects_chapt(objects: $objects) {
          affected_rows
        }
      }
    `;
    this.props.createChapter(query, data, currentProjectId);
  }

  // Delete the selected chapter
  deleteChapter(id, event) {
    let index = this.props.project.findIndex(
      (x) => x.proj_id === parseInt(this.props.match.params.projectid, 10)
    );
    if (this.props.project[index].proj_owner === this.props.user.id) {
      this.props.deleteChapter(id, this.props.match.params.projectid);
    }
  }

  // Update the profile for the current project
  updateProjectProfile(data) {
    let index = this.props.project.findIndex(
      (x) => x.proj_id === parseInt(this.props.match.params.projectid, 10)
    );

    let mutation = gql`
      mutation updateProject {
        update_simcaa_t_projects(
          where: { id: { _eq: ${this.props.project[index].proj_id} } }
          _set: { proj_profile: "${escapeQuotes(data)}" }
        ) {
          affected_rows
        }
      }
    `;

    this.props.updateProfileProject(
      mutation,
      {},
      () => {
        let projects = this.props.project.slice();
        projects[index].proj_profile = JSON.stringify(data);
        this.props.updateStoreProjects(projects);
      },
      false
    );
  }

  // Force unlock of the chapter if the current user is the admin or the project owner
  forceUnlockChapter(id, event) {
    let query = gql`
      mutation updateChapter {
        update_simcaa_t_projects_chapt(_set: {chapt_user_block: 0}, where: {id: {_eq: ${id}}}) {
          affected_rows
        }
      }
    `;
    this.props.updateChapter(query, null, this.props.match.params.projectid);
  }

  // redirect to homepage and clean the chapter list/current selected project
  redirectProject() {
    this.props.resetProject([]);
    this.props.selectedProjectID(-1);
    this.props.history.push("/home");
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;

    var prjID = this.props.project.findIndex(
      (x) => x.proj_id === parseInt(this.props.match.params.projectid, 10)
    );
    if (prjID < 0) {
      prjID = 0;
    }
    if (this.props.chaptHasErrored || this.props.chaptIsLoading) {
      return (
        <Dimmer active={this.props.chaptIsLoading} page>
          <Loader active inline="centered" size="massive" />
        </Dimmer>
      );
    }

    let localChapters = this.props.chapters;
    localChapters = localChapters.map((item, index) => {
      return (
        <ChapterUI
          key={index}
          forceUnlockChapter={this.forceUnlockChapter.bind(this)}
          deleteChapter={this.deleteChapter.bind(this)}
          duplicateChapter={this.props.duplicateChapter.bind(this)}
          updateChapter={this.props.updateChapter.bind(this)}
          chapter={item}
          user={this.props.user}
          projectId={parseInt(this.props.match.params.projectid, 10)}
          projectOwner={this.props.project[prjID].proj_owner}
          projectBlocked={this.props.project[prjID].proj_blocked}
        />
      );
    });

    let isProjBlockedOrNotOwner =
      this.props.project[prjID].proj_blocked === 1 ? true : false;
    if (this.props.project[prjID].proj_owner === this.props.user.id) {
      isProjBlockedOrNotOwner = false;
    }

    return (
      <div>
        <Menu>
          <Menu.Item>
            <Button color="red" onClick={this.redirectProject.bind(this)}>
              {t("PRJ_MNU_BACK")}
            </Button>
          </Menu.Item>
          <Menu.Item disabled={isProjBlockedOrNotOwner}>
            <NewProfileForm
              className="icon-pointer"
              size="big"
              edit="button"
              data={this.props.project[prjID].proj_profile}
              updateProjectProfile={this.updateProjectProfile.bind(this)}
            />
          </Menu.Item>
          <Menu.Item>
            <Button as={Link} to="/preload">
              {t("HOME_NAVBAR_MANAGE_PRELOAD")}
            </Button>
          </Menu.Item>
          <Menu.Item>
            <Breadcrumb>
              <Breadcrumb.Section
                link
                onClick={this.redirectProject.bind(this)}
              >
                home
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>
                {this.props.project[prjID].proj_name}
              </Breadcrumb.Section>
            </Breadcrumb>
          </Menu.Item>
          <Menu.Item>
            {"(Progetto: " + this.props.match.params.projectid + ")"}
          </Menu.Item>
        </Menu>

        <Card.Group style={{ marginLeft: "10px" }}>
          {localChapters}
          {!isProjBlockedOrNotOwner ? (
            <Can perform="can_create_project" or="can_manage_project">
              <Card style={{ textAlign: "center" }}>
                <Card.Content header={t("PRJ_LBL_NEWCHAPT")} />
                <Card.Content>
                  <NewChapterForm
                    createChapter={this.createNewChapter.bind(this)}
                    className="icon-pointer"
                    nameIcon="add square"
                    sizeIcon="huge"
                  />
                </Card.Content>
                <Card.Content extra>{t("PRJ_LBL_INFO")}</Card.Content>
              </Card>
            </Can>
          ) : null}
        </Card.Group>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    chapters: state.chapterData,
    project: state.projectData,
    chaptIsLoading: state.chapterDataIsLoading,
    chaptHasErrored: state.chapterDataHasErrored,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchChapter: (query, limit, page, id) =>
      dispatch(chapterDataFetchData(query, limit, page, id)),
    createChapter: (mutation, variables, projectId) =>
      dispatch(chapterDataCreateData(mutation, variables, projectId)),
    updateChapter: (mutation, variables, projectId) =>
      dispatch(chapterDataUpdateData(mutation, variables, projectId)),
    deleteChapter: (id, projectId) =>
      dispatch(chapterDataDeleteData(id, projectId)),
    updateProfileProject: (mutation, variables, cb, reFetch) =>
      dispatch(projectDataUpdateData(mutation, variables, cb, reFetch)),
    updateStoreProjects: (projects) =>
      dispatch(projectDataFetchDataSuccess(projects)),
    resetProject: (value) => dispatch(chapterDataFetchDataSuccess(value)),
    duplicateChapter: (id) => dispatch(duplicateChapter(id)),
    selectedProjectID: (id) => dispatch(selectedProjectID(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(translate("translations")(Project)));



// WEBPACK FOOTER //
// ./src/containers/project/Project.js